import React, { useState, useEffect } from "react";
import moment from "moment";
import _ from "lodash";
import Chart from "react-apexcharts";
import Loading from "../common/loading";

const Area = ({
  parameter,
  data,
  group,
  targetValue,
  targetParameter,
  targetLabel,
  type,
  height,
  minY,
  maxY,
  colour
}) => {
  const [options, setOptions] = useState({
    chart: { id: "basic-area" },
    xaxis: { categories: [] }
  });
  const [series, setSeries] = useState([{ name: "series-1", data: [] }]);

  useEffect(() => {
    if (!_.isEmpty(data)) {
      setSeries([
        {
          name: data[parameter].Name,
          data: data[parameter].data.map(d => {
            return {
              y: d.PARAM_VALUE
                ? d.PARAM_VALUE.toFixed(data[parameter].Precision)
                : 0,
              x: moment(d.REAL_DATE).hour(d.REAL_HOUR)
            };
          })
        }
      ]);
      setOptions({
        annotations: {
          yaxis: (targetValue || targetParameter) && [
            {
              y: targetValue
                ? targetValue
                : data[targetParameter].data.length > 0
                ? data[targetParameter].data[0].PARAM_VALUE
                : "",
              borderColor: "#e67e22",
              label: {
                borderColor: "#e67e22",
                style: {
                  color: "#fff",
                  background: "#e67e22"
                },
                text: targetLabel ? targetLabel : "Target"
              }
            }
          ]
        },
        colors: colour ? [colour] : ["#65B32E"],
        stroke: { curve: "straight" },
        dataLabels: { enabled: false },
        chart: {
          id: parameter,
          group: group,
          // sparkline: { enabled: true },
          toolbar: { show: false },
          zoom: { enabled: false }
        },
        title: {
          text: data[parameter].Name
        },
        xaxis: {
          type: "datetime",
          labels: { show: true },
          axisTicks: { show: true }
        },
        yaxis: {
          labels: {
            minWidth: 20
          },
          min: min => {
            return minY >= 0 ? minY : min;
          },
          max: max => {
            return maxY > max ? maxY : max;
          }
        },
        tooltip: {
          theme: "dark",
          x: { show: false },
          marker: { show: false },
          y: {
            title: {
              formatter: () => {
                return "";
              }
            }
          }
        }
      });
    }
  }, [
    data,
    parameter,
    group,
    targetValue,
    targetParameter,
    targetLabel,
    minY,
    maxY,
    colour
  ]);

  return (
    <div>
      {options.chart.id === "basic-area" ? (
        <Loading />
      ) : (
        <Chart
          options={options}
          series={series}
          type={type ? type : "area"}
          height={height && height}
        />
      )}
    </div>
  );
};

export default Area;
